<div class="lm-report-personalization" soho-busyindicator [text]="' '" [displayDelay]="20" [overlayOnly]="true">

  <div *ngIf="true then CONTEXT_FORM"></div>
  <div soho-tabs>
    <div soho-tab-list-container>
      <ul soho-tab-list>
        <ng-container *ngIf="!isCubeView">
          <li soho-tab [disabled]="disableTabs">
            <a soho-tab-title tabId="tabs-normal-column" data-automation-id="lm-personalization-column-tab">{{ 'ListPersonalizationColumnTab' | translate }}</a>
          </li>
          <li *ngIf="!isPrimaryList || this.mode === 'personalizeReport' || this.mode === 'createReportFromMenu' || this.mode === 'createReportFromBanner'" soho-tab [disabled]="disableTabs">
            <a soho-tab-title tabId="tabs-normal-filter" data-automation-id="lm-personalization-filter-tab">{{ 'ListPersonalizationFilterTab' | translate }}</a></li>
          <li soho-tab [disabled]="disableTabs">
            <a soho-tab-title tabId="tabs-normal-display" data-automation-id="lm-personalization-display-tab">{{ 'ListPersonalizationDisplayTab' | translate }}</a>
          </li>
            <ng-container *ngIf="displayFields?.length > 0">
              <li soho-tab [disabled]="disableTabs">
                <a soho-tab-title tabId="tabs-normal-sort" data-automation-id="lm-personalization-sorting-tab">{{ 'SortingTabLabel' | translate }}</a>
              </li>
              <li soho-tab [disabled]="disableTabs">
                <a soho-tab-title tabId="tabs-normal-total" data-automation-id="lm-personalization-totaling-tab">{{ 'TotalingTabLabel' | translate }}</a>
              </li>
            </ng-container>
          <li>
            <a soho-tab-title tabId="tabs-normal-datasource" data-automation-id="lm-personalization-data-source-tab">{{ 'ListPersonalizationDataSourceTab' | translate }}</a>
          </li>
        </ng-container>
        <ng-container *ngIf="isCubeView">
          <li soho-tab>
            <a soho-tab-title tabId="tabs-normal-dimensions" data-automation-id="lm-personalization-cube-dimensions-tab">{{ 'Dimensions' | translate }}</a>
          </li>
          <li soho-tab>
            <a soho-tab-title tabId="tabs-normal-column" data-automation-id="lm-personalization-cube-measures-tab">{{ 'Measures' | translate }}</a>
          </li>
          <li soho-tab>
            <a soho-tab-title tabId="tabs-normal-display" data-automation-id="lm-personalization-cube-display-tab">{{ 'ListPersonalizationDisplayTab' | translate }}</a>
          </li>
          <li>
            <a soho-tab-title tabId="tabs-normal-datasource" data-automation-id="lm-personalization-data-source-tab">{{ 'ListPersonalizationDataSourceTab' | translate }}</a>
          </li>
        </ng-container>
      </ul>
    </div>
    <div soho-tab-panel-container>
      <ng-container *ngIf="!isCubeView">
        <div [ngTemplateOutlet] = "COLUMNS_TAB_CONTENT"></div>
        <div *ngIf="!isPrimaryList || this.mode === 'personalizeReport' || this.mode === 'createReportFromBanner' || this.mode === 'createReportFromMenu'" [ngTemplateOutlet]="FILTER_TAB_CONTENT"></div>
        <div [ngTemplateOutlet]="DISPLAY_TAB_CONTENT"></div>
        <div [ngTemplateOutlet]="SORT_TAB_CONTENT"></div>
        <div [ngTemplateOutlet]="TOTAL_TAB_CONTENT"></div>
        <div [ngTemplateOutlet]="DATA_SOURCE_TAB_CONTENT"></div>
      </ng-container>
      <ng-container *ngIf="isCubeView">
        <div [ngTemplateOutlet]="DIMENSIONS_TAB_CONTENT"></div>
        <div [ngTemplateOutlet]="COLUMNS_TAB_CONTENT"></div>
        <div [ngTemplateOutlet]="DISPLAY_TAB_CONTENT"></div>
        <div [ngTemplateOutlet]="DATA_SOURCE_TAB_CONTENT"></div>
      </ng-container>
    </div>
  </div>
<!--  </div>-->

<!--TEMPLATE SUB PARTS-->
<ng-template #CONTEXT_FORM>

  <div class="row titleSharing-fields-container">
    <div class="column">
      <div class="field">
        <ng-container [ngTemplateOutlet]="TITLE_MODE" [ngTemplateOutletContext]="{ onEdit, template, id: 'reportName', value: model.name, classList: 'text-primary' }">
          <ng-template #template>
            <input
              class="input-xl"
              soho-input
              name="reportName"
              id="reportName"
              data-automation-id="lm-personalization-reportName"
              spellcheck="false"
              soho-trackdirty
              data-validate="notEmpty"
              placeholder="{{ 'EnterReportTitle' | translate }}"
              (dirty)="onTitleDirty($event)"
              (afterResetDirty)="onTitleAfterResetDirty($event)"
              (pristine)="onTitlePristine($event)"
              [(ngModel)]="model.name"
            >
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="row titleSharing-fields-container form-layout-compact">
    <ng-container *ngIf="allowSharing">
      <div class="one-fourth column">
        <div class="field">
          <label soho-label for="sharing">{{ 'CreateReportSharing' | translate }}</label>
          <select
            soho-dropdown
            class="input-mm"
            id="sharing"
            noSearch
            name="sharing"

            [attributes]="allowSharingDropdownAttributes"
            [source]="sharingSource"
            (change)="onSharingChange($event)"
            soho-trackdirty
            [(ngModel)]="model.sharing">
            <option *ngFor="let share of sharing" [value]="share.value">{{share.label}}</option>
          </select>
        </div>
      </div>
      <div class="one-fourth column">
        <ng-container *ngIf="actorGroupSharing">
          <div class="field">
            <label soho-label class="required">{{ 'CreateReportActorGroupLabel' | translate }}</label>
            <input
              class="input-mm"
              data-automation-id="lm-personalization-actor-group"
              soho-lookup
              [click]="onLookupClick"
              [field]="onLookupField"
              soho-trackdirty
              soho-busyindicator blockUI="true" displayDelay="0"
              id="{{testVersion3 ? 'report-personalization-actorGroup' : 'actorGroup'}}"
              [(ngModel)]="model.actorGroup"
            />
          </div>
        </ng-container>
        <ng-container *ngIf="roleSharing">
          <div class="field">
            <label soho-label class="required">{{ 'CreateReportRoleLabel' | translate }}</label>
            <input
              class="input-mm"
              data-automation-id="lm-personalization-role"
              soho-lookup
              [click]="onLookupClick"
              [field]="onLookupField"
              soho-trackdirty
              soho-busyindicator blockUI="true" displayDelay="0"
              id='report-personalization-role'
              [(ngModel)]="model.role"
            />
          </div>
        </ng-container>
        <ng-container *ngIf="roleGroupSharing">
          <div class="field">
            <label soho-label class="required">{{ 'CreateReportRoleGroupLabel' | translate }}</label>
            <input
              class="input-mm"
              data-automation-id="lm-personalization-role-group"
              soho-lookup
              [click]="onLookupClick"
              [field]="onLookupField"
              soho-trackdirty
              soho-busyindicator blockUI="true" displayDelay="0"
              id='report-personalization-roleGroup'
              [(ngModel)]="model.roleGroup"
            />
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #COLUMNS_TAB_CONTENT>
  <div soho-tab-panel tabId="tabs-normal-column">
    <div class="row">&nbsp;</div>
    <div class="row form-layout-compact">
      <div class="five columns">
        <soho-toolbar-flex noActionsButton=true hasMoreButton=false>
          <soho-toolbar-title></soho-toolbar-title>
          <soho-toolbar-flex-section>
            <button
              data-automation-id="lm-personalization-add-field-btn"
              type="button"
              id="add-item"
              soho-menu-button
              icon="add"
              menu="addColumnMenu"
              [disabled]="disableTabs"
              removeOnDestroy="true">{{ 'Add' | translate}}</button>
            <ul soho-popupmenu id="addColumnMenu">
              <li soho-popupmenu-item>
                <a soho-popupmenu-label data-automation-id="lm-personalization-add-field-menuitem" (click)="onAddField()">{{ 'ListPersonalizationAddFieldButtonLabel40' | translate }}</a>
              </li>
              <li *ngIf="!isColumnarView && !isCubeView" soho-popupmenu-item>
                <a soho-popupmenu-label data-automation-id="lm-personalization-add-compute-menuitem"(click)="onAddCompute()">{{ 'ListPersonalizationAddComputeButtonLabel40' | translate }}</a>
              </li>
            </ul>
            <button
              type="button"
              id="show-label"
              data-automation-id="lm-personalization-show-label-btn" 
              soho-menu-button
              menu="showLabelMenu" 
              [disabled]="disableTabs"
              removeOnDestroy="true">{{showLabelText}}</button>
            <ul soho-popupmenu id="showLabelMenu">
              <li soho-popupmenu-item><a soho-popupmenu-label data-automation-id="lm-personalization-show-label-menuitem" (click)="onShowLabel(true)">{{ 'ShowLabel' | translate }}</a></li>
              <li soho-popupmenu-item><a soho-popupmenu-label data-automation-id="lm-personalization-show-field-menuitem" (click)="onShowLabel(false)">{{ 'ShowField' | translate }}</a></li>
            </ul>
            <button
              data-automation-id="lm-personalization-delete-field-btn"
              id="delete-item"
              [disabled]="disableRemove"
              soho-button="icon"
              icon="delete" (click)="onRemoveField()" [disabled]="disableTabs">{{ 'ListPersonalizationRemoveButtonLabel' | translate }}</button>
          </soho-toolbar-flex-section>
        </soho-toolbar-flex>
        <div class="scrollable-flex-content" style="margin-top: 5px;"
            *ngIf="columnGridOptions"
            data-automation-id="lm-personalization-field-data-grid"
            soho-datagrid  #columnDataGridComponent
            [attr.attributes]="fieldDataGridAttributes"
            [attr.id]="columnDataGridComponent"
            [gridOptions]="this.columnGridOptions"
            (rowClicked)="onRowClicked($event)">
        </div>
      </div>
      <div *ngIf="selectedField" class="seven columns detail-column">
        <ng-container *ngIf="!selectedField.compute">
          <!-- ColumnEditorFieldDetailsLabel -->
            <span class="text-secondary lm-bold font-size-md">{{ 'ColumnEditorFieldDetailsLabel' | translate }}</span>
            <div class="details" style="margin-top: 10px;">
              <div class="row">
                <div class="compound-field">
                  <ng-container [ngTemplateOutlet]="FIELD_MODE" [ngTemplateOutletContext]="{ onEdit, template, id: 'fieldName', label: 'ColumnEditorFieldLabel', value: selectedField.name }">
                    <ng-template #template>
                      <input
                        #fieldName
                        class="input-md"
                        id="name"
                        data-automation-id="lm-personalization-fieldName"
                        type="text"
                        name="fieldName"
                        soho-autocomplete
                          [source]="autoCompleteSource"
                          [filterMode]="null"
                          [delay]="400"
                          (selected)="onAutoCompleteSelected($event)"
                          (change)="onFieldChange()"
                          (focusout)="validateField()"
                        soho-alert
                        attr.data-validate="required"
                        aria-required="true"
                        soho-trackdirty
                        [(ngModel)]="selectedField.name"
                        soho-busyindicator
                        [blockUI]="false"
                        [displayDelay]="500"
                      >
                      <button type="button" class="btn-primary" style="margin-left: 10px;" (click)="onGetFieldQualifier($event)" *ngIf="selectedField.type === 'Field'"
                          data-automation-id="field-picker-advanced-search"><span style="font-weight: normal;" title="{{ 'ColumnEditorPlaceholderSearch' | translate }}"
                      >{{ 'AdvancedSearchLabel' | translate }}</span></button>

                    </ng-template>
                  </ng-container>
                </div>
              </div>

              <div class="row">
                <div class="compound-field">
                  <div *ngIf="selectedField.type === 'Field'">
                    <ng-container [ngTemplateOutlet]="FIELD_MODE" [ngTemplateOutletContext]="{ onEdit, template, id: 'field-label', label: 'ColumnEditorLabelLabel', value: selectedField.placeholder }">
                      <ng-template #template>
                        <input
                          class="input-md"
                          data-automation-id="lm-personalization-field-label"
                          type="text"
                          name="label"
                          #columnlabel
                          id="label"
                          soho-trackdirty
                          [(ngModel)]="selectedField.placeholder"
                          (dirty)="onLabelDirty()"
                          (pristine)="onLabelDirty()">
                      </ng-template>
                    </ng-container>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="!isColumnarView && selectedField.type === 'Field'">
                <div class="row ">
                  <div class="field">
                    <label soho-label aria-hidden></label>
                    <input #allowUpdateOption
                      data-automation-id="lm-personalization-field-allow-update"
                      soho-checkbox type="checkbox" class="checkbox" id="allowUpdate"
                      soho-trackdirty [(ngModel)]="selectedField.allowUpdate" [disabled]="!selectedField.canUpdate" (change)="onChange()">
                    <label *ngIf="selectedField.allowUpdate?.lpl" soho-label for="allowUpdate" data-automation-id="lm-personalization-field-allow-update-label" [forCheckBox]="true">{{ 'UpdatableWhen' | translate }}  {{ selectedField.allowUpdate?.lpl }}</label>
                    <label *ngIf="!selectedField.allowUpdate?.lpl" soho-label for="allowUpdate" data-automation-id="lm-personalization-field-allow-update-label" [forCheckBox]="true">{{ 'ListPersonalizationAllowUpdate' | translate }}</label>
                  </div>
                </div>
              </ng-container>
            </div>

          <soho-accordion class="" [allowOnePane]="false">
            <soho-accordion-header id="alertsHeader" data-automation-id="lm-personalization-alerts-accordion-header" class="" [ngClass]="{ 'hidden' : selectedField.type !== 'Field' || isCubeView }">{{ 'FieldEditorAlertsTab' | translate }}</soho-accordion-header>
            <soho-accordion-pane class="personalization-pane-div" [ngClass]="{ 'hidden' : selectedField.type !== 'Field' || isCubeView }">
              <div class="scrollable-flex">
                <soho-toolbar-flex noActionsButton=true hasMoreButton=false>
                  <soho-toolbar-title></soho-toolbar-title>
                  <soho-toolbar-flex-section>
                    <!--                        <button id="add-item" soho-button="icon" icon="add" (click)="onAddAlert()">Add</button>-->
                    <button
                            data-automation-id="lm-personalization-add-alert-btn"
                            soho-menu-button icon="add" menu="addAlertMenu" [disabled]="hasAllAlerts" type="button" id="add-Alert"></button>
                    <ul soho-popupmenu id="addAlertMenu">
                      <li *ngIf="noRedAlert" soho-popupmenu-item><a soho-popupmenu-label data-automation-id="lm-personalization-red-alert-menuitem" (click)="onAddAlert(1)">{{ 'FieldEditorAddRedAlert' | translate }}</a></li>
                      <li *ngIf="noYellowAlert" soho-popupmenu-item><a soho-popupmenu-label data-automation-id="lm-personalization-yellow-alert-menuitem" (click)="onAddAlert(2)">{{ 'FieldEditorAddYellowAlert' | translate }}</a></li>
                      <li *ngIf="noGreenAlert" soho-popupmenu-item><a soho-popupmenu-label data-automation-id="lm-personalization-green-alert-menuitem" (click)="onAddAlert(3)">{{ 'FieldEditorAddGreenAlert' | translate }}</a></li>
                      <li *ngIf="noBlueAlert" soho-popupmenu-item><a soho-popupmenu-label data-automation-id="lm-personalization-blue-alert-menuitem" (click)="onAddAlert(4)">{{ 'FieldEditorAddBlueAlert' | translate }}</a></li>
                    </ul>
                    <button
                            data-automation-id="lm-personalization-delete-alert-btn"
                            id="delete-alert" soho-button="icon" icon="delete" (click)="onDeleteAlert()">Delete</button>
                  </soho-toolbar-flex-section>
                </soho-toolbar-flex>
                <div class="alerts-data-grid"
                    data-automation-id="lm-personalization-alert-data-grid"
                    *ngIf="alertGridOptions"
                    soho-datagrid #alertDataGridComponent
                    [attr.id]="alertDataGridComponent"
                    [attr.attributes]="fieldAlertDataGridAttributes"
                    [gridOptions]="this.alertGridOptions"
                    (rowClicked)="onAlertRowClicked($event)"
                    (rowAdd)="onAlertRowAdd($event)"
                    (rowRemove)="onAlertRowRemove($event)"
                    (cellchange)="onCellChange($event)"></div>
              </div>
            </soho-accordion-pane>
            <soho-accordion-header id="sortTotalHeader" data-automation-id="lm-personalization-sort-order-accordion-header" class=""  [ngClass]="{ 'hidden' : selectedField.type !== 'Field' || isCubeView}" >{{ 'FieldEditorTotalSortTab' | translate }}</soho-accordion-header>
            <soho-accordion-pane class="personalization-pane-div" [ngClass]="{ 'hidden' : selectedField.type !== 'Field' || isCubeView }">
              <div class="row top-padding">
                  <div *ngIf="!isColumnarView" class="field six columns">
                      <div *ngIf="selectedField.sortOrder" class="row">
                        <div class="four columns">
                          <div class="field top-margin">
                            <input
                              data-automation-id="lm-personalization-field-default-sort"
                              soho-checkbox
                              type="checkbox"
                              id="defaultSortColumn"
                              name="defaultSortColumn"
                              soho-trackdirty
                              [disabled]="!this.selectedField.sortOrder"
                              [(ngModel)]="selectedField.defaultSort"
                                (change)="onSortChange(selectedField)">
                            <label soho-label [forCheckBox]="true" for="defaultSortColumn">{{ 'ListPersonalizationDefaultSortLabel40' | translate }}</label>
                          </div>
                        </div>
                        <div class="four columns">
                          <div class="field top-margin">
                            <input
                              data-automation-id="lm-personalization-field-sort-descending"
                              soho-checkbox
                              [disabled]="!selectedField.defaultSort"
                              type="checkbox"
                              id="sortDescending"
                              name="sortDescending"
                              soho-trackdirty
                              [(ngModel)]="selectedField.sortDescending"
                                (change)="onSortDescendingChange(selectedField)">
                            <label soho-label [forCheckBox]="true" for="sortDescending">{{ 'ListPersonalizationSortDescendingLabel40' | translate }}</label>
                          </div>
                        </div>
                      </div>
                      <label soho-label for="sortOrder">{{ 'ColumnEditorSortOrderLabel' | translate }}</label>
                      <select #sortOrder
                          soho-dropdown
                          data-automation-id="lm-personalization-field-sort-order"
                          [attributes]="fieldSortOrderDropdownAttributes"
                          noSearch
                          id="sortOrder"
                          name="sortOrder"
                          soho-trackdirty
                            (ngModelChange)="onSortOrderChanged(selectedField)"
                          [(ngModel)]="selectedField.sortOrder"
                      >
                        <option *ngFor="let sort of sortOrders" [value]="sort.value">{{sort.label}}</option>
                      </select>
                        <ng-container *ngIf="selectedField.sortOrder">
                        <div id="sortOrderField" name="sortOrderField" class="fieldset">
                            <div *ngIf="selectedField.sortOrder" class="summary-form">
                            <label style="font-weight:bold">{{ 'Fields' | translate }}</label>
                              <div *ngFor="let item of setSpecs[selectedField.sortOrder].sortFields">
                                <label *ngIf="item.sortBreak" soho-label [style.text-indent]="'0px'">*{{item.name}}</label>
                                <label *ngIf="!item.sortBreak" soho-label [style.text-indent]="'8px'">{{item.name}}</label>
                            </div>
                              <div>
                              <br>
                              <label>{{ 'ColumnEditorSubTotalBreakPointMessage' | translate }}</label>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                  </div>
                  <div class="field six columns">
                      <label soho-label for="totaling">{{ 'ColumnEditorColumnTotalingLabel' | translate }}</label>
                    <select
                        soho-dropdown
                        data-automation-id="lm-personalization-field-totaling"
                        [attributes]="fieldTotalingDropdownAttributes"
                        noSearch
                        id="totaling"
                        name="totaling"
                        [source]="totalSource"
                        soho-trackdirty
                        [(ngModel)]="selectedField.totaling"
                        (change)="onTotalTypeChanged(selectedField)"
                    >
                        <option *ngFor="let option of totaling" [value]="option.value">{{option.label}}</option>
                    </select>
                  </div>
              </div>
            </soho-accordion-pane>
          </soho-accordion>
        </ng-container>

        <ng-container *ngIf="selectedField.compute">
          <div class="row top-padding">
            <div class="compound-field">
              <ng-container [ngTemplateOutlet]="FIELD_MODE" [ngTemplateOutletContext]="{ onEdit, template, id: 'compute-label', label: 'ColumnEditorLabelLabel', value: selectedField.label }">
                <ng-template #template>
                  <input
                    data-automation-id="lm-personalization-compute-label"
                    type="text"
                    name="computeLabel"
                    id="computeLabel"
                    soho-trackdirty
                    (dirty)="onLabelDirty()"
                    (pristine)="onLabelDirty()"
                    [(ngModel)]="selectedField.placeholder">
                </ng-template>
              </ng-container>
            </div>
          </div>

          <div class="row">
            <div class="field nine columns">
              <textarea
                data-automation-id="lm-personalization-compute-lpl"
                soho-alert
                soho-textarea
                id="compute"
                name="compute"
                attr.data-validate="{{isRequired('compute')}}"
                spellcheck="false"
                (change)="onChange()"
                (focusout)="validateCompute()"
                soho-trackdirty [(ngModel)]="selectedField.name">
              </textarea>
            </div>
            <div class="field two columns">
              <button
                      data-automation-id="lm-personalization-compute-builder-btn"
                      soho-button="primary"
                      (click)="onBuildComputeCondition()"
                      title="{{'BuilderNoEllipses' | translate }}"
              >{{ 'BuilderNoEllipses' | translate}}</button>
            </div>
          </div>
          <div class="row">
            <div class="field four columns">
                <label soho-label for="computeTotaling">{{ 'ColumnEditorColumnTotalingLabel' | translate }}</label>
              <select
                  data-automation-id="lm-personalization-compute-totaling"
                  soho-dropdown
                  noSearch
                  id="computeTotaling"
                  name="computeTotaling"
                  [source]="totalSource"
                  soho-trackdirty
                  [(ngModel)]="selectedField.totaling"
                    (change)="onTotalTypeChanged(selectedField)">
                  <option *ngFor="let option of totaling" [value]="option.value">{{option.label}}</option>
              </select>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #FILTER_TAB_CONTENT>
  <div soho-tab-panel tabId="tabs-normal-filter">
    <ng-container *ngIf="model.baseFilter && this.mode !== 'personalizeList'">
      <div class="row top-padding">
        <div class="field eleven columns">
          <label>{{ 'ListPersonalizationBaseFilterLabel' | translate : this.model.listName }}</label>
          <p class="hide-white-space lm-text-data">{{ model.baseFilter }}</p>
        </div>
      </div>
    </ng-container>
    <div class="row top-padding">
      <div class="field eleven columns">
        <label>{{ 'ListPersonalizationFilterLabel' | translate }}</label>
      </div>
    </div>
    <div class="row">
      <div class="field eight columns">
        <textarea #filterCondition
            [attr.id]="'filterCriteria'"
            data-automation-id="lm-personalization-filter-criteria"
            name="filterCriteria"
            spellcheck="false"
            soho-textarea
            soho-alert
            [id]="'lm-personalization-instance-selection-alert'"
            soho-trackdirty
            [(ngModel)]="model.conditionString"
            (ngModelChange)="instanceSelectionValidator$.next($event)">
        </textarea>
      </div>
      <div class="field two columns">
        <button
            data-automation-id="lm-personalization-filter-criteria-builder-btn"
            soho-button="primary"
            (click)="onBuildButtonEvent($event)"
        >{{ 'BuilderNoEllipses' | translate}}</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #DISPLAY_TAB_CONTENT>
  <div soho-tab-panel tabId="tabs-normal-display" class="form-layout-compact">
    <lm-list-personalization-display [model]="model" [appReport]="appReport" class="top-padding"></lm-list-personalization-display>
  </div>
</ng-template>

  <ng-template #SORT_TAB_CONTENT>
    <div soho-tab-panel tabId="tabs-normal-sort">
      <ng-container [ngTemplateOutlet]="SORTBY"></ng-container>
    </div>
  </ng-template>

  <ng-template #TOTAL_TAB_CONTENT>
    <div soho-tab-panel tabId="tabs-normal-total">
      <ng-container [ngTemplateOutlet]="TOTAL_FIELDS"></ng-container>
      <ng-container *ngIf="hasTotaling && !isColumnarView" [ngTemplateOutlet]="SUBTOTAL_BY"></ng-container>
    </div>
  </ng-template>

<ng-template #DATA_SOURCE_TAB_CONTENT>
  <div soho-tab-panel tabId="tabs-normal-datasource">
    <lm-list-personalization-source [model]="model" class="top-padding"></lm-list-personalization-source>
  </div>
</ng-template>
<ng-template #DIMENSIONS_TAB_CONTENT>
  <div class="row top-padding" soho-tab-panel tabId="tabs-normal-dimensions">
    <lm-cube-dimensions-dialog 
      [parentContainer]="cubeParent"
      [listSpec]="listSpec" [listState]="cubeViewState" [dvsLastFixedIndex]="dataViewSet?.cubeInfo?.lastFixedIndex"
      [currentDimensions]="dataViewSet?.cubeInfo?.currentDims" [availableDimensions]="dataViewSet?.cubeInfo?.availableDims"
      [businessClass]="businessClass" [listName]="listName" [userfolderId]="userFolderId"
    ></lm-cube-dimensions-dialog>
  </div>
</ng-template>

  <ng-template #FIELD_MODE let-onEdit="onEdit" let-template="template" let-id="id" let-label="label" let-value="value" let-classList="classList">
    <ng-container *ngIf="{ isEditing: false } as context">
      <div class="field">
        <ng-container *ngIf="label">
          <label soho-label [attr.for]="id">{{ label | translate}}</label>
        </ng-container>
        <ng-container *ngIf="context.isEditing || isNewField">
          <ng-container *ngTemplateOutlet="template"></ng-container>
          <!-- ListPersonalizationDoneButtonLabel -->
          <button type="button" class="btn btn-link hide-focus" style="margin-left: 5px;" [disabled]="!value" [attr.data-automation-id]="'lm-personalization-'+ id +'-button-done'" (click)="onEdit(context, false)"><span style="font-weight: normal;">{{ 'ListPersonalizationDoneButtonLabel' | translate}}</span></button>
        </ng-container>
        <ng-container *ngIf="!context.isEditing && !isNewField">
          <p
                  [id]="id"
                  [attr.data-automation-id]="'lm-personalization-' + id"
                  class="hide-white-space lm-text-data"
                  [ngClass]="classList ? classList : 'text-default'"
          > {{ value }}
            <!-- ListPersonalizationEditButtonLabel -->
            <button type="button" class="btn btn-link btn-secondary hide-focus" [disabled]="!value" [attr.data-automation-id]="'lm-personalization-'+ id +'-button-edit'" (click)="onEdit(context, true)"><span style="font-weight: normal;">{{ 'ListPersonalizationEditButtonLabel' | translate}}</span></button>
            <button type="button" class="btn btn-link btn-secondary hide-focus" [attr.data-automation-id]="'lm-personalization-'+ id +'-button-edit-operator'" (click)="onGetFieldOperatorQualifier(context, false)" *ngIf="selectedField.type === 'Field' && enableOperator && id==='fieldName' && selectedField.isValid && selectedField.supportsOperator"><span style="font-weight: normal;" title="Edit Operator">{{editOperatorLabel}}</span></button>
          </p>
        </ng-container>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #TITLE_MODE let-onEdit="onEdit" let-template="template" let-id="id" let-label="label" let-value="value" let-classList="classList">
    <ng-container *ngIf="{ isEditing: false } as context">
      <div class="field">
        <ng-container *ngIf="label">
          <label soho-label [attr.for]="id">{{ label | translate}}</label>
        </ng-container>
        <ng-container *ngIf="context.isEditing || isEditing">
          <ng-container *ngTemplateOutlet="template"></ng-container>
          <!-- ListPersonalizationDoneButtonLabel -->
          <button type="button" class="btn btn-link hide-focus" style="margin-left: 5px;" [disabled]="!value" [attr.data-automation-id]="'lm-personalization-'+ id +'-button-done'" (click)="onEdit(context, false)"><span style="font-weight: normal;">{{ 'ListPersonalizationDoneButtonLabel' | translate}}</span></button>
        </ng-container>
        <ng-container *ngIf="!context.isEditing && !isEditing">
          <p
                  [id]="id"
                  [attr.data-automation-id]="'lm-personalization-' + id"
                  class="hide-white-space lm-text-data"
                  [ngClass]="classList ? classList : 'text-default'"
          > {{ value }}
            <!-- ListPersonalizationEditButtonLabel -->
            <button type="button" class="btn btn-link hide-focus" [disabled]="!value" [attr.data-automation-id]="'lm-personalization-'+ id +'-button-edit'" (click)="onEdit(context, true)"><span style="font-weight: normal;">{{ 'ListPersonalizationEditButtonLabel' | translate}}</span></button>
          </p>
          <ng-container *ngIf="dataView.fields['AsOfDate'] && dataView.fields['DataOption'] === 'live'">
            <header class="lm-mustache-text">{{ '' | asOfDate:dataView.fields['AsOfDate'] }}</header>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #HEADER_WITH_HELP_TEXT let-headerTitle="headerTitle" let-helpText="helpText" let-dai="dai">
    <div class="lm-flex-row-container-no-wrap lm-padding-top">
      <div class="font-size-md lm-bold lm-padding-right-sm" attr.data-automation-id="{{dai}}-header">{{headerTitle}}</div>
      <lm-mouse-over-text [mouseOverTextContents]="helpText"></lm-mouse-over-text>
    </div>
  </ng-template>

  <ng-template #SORTBY>
    <ng-container [ngTemplateOutlet]="HEADER_WITH_HELP_TEXT"
      [ngTemplateOutletContext]="{ headerTitle: sortByHeaderTitle, helpText: sortByHelpText, dai: 'lm-sort-by' }">
    </ng-container>
    <div class="lm-flex-row-responsive-container">
     <ng-container [ngTemplateOutlet]="SORT_WIDGET"></ng-container>
      <div *ngIf="!this.isColumnarView && this.displayFields?.length > 0" class="widget lm-report-widget lm-sort-total-block-widget">
        <button data-automation-id="lm-personalization-add-sort-by-btn"
          icon="add"
          soho-button="button"
          (click)="onAddSort()"
          class="field btn-primary">{{'AddSortToColumn' | translate}}</button>
      </div>
    </div>
  </ng-template>

  <ng-template #SUBTOTAL_BY>
    <ng-container [ngTemplateOutlet]="HEADER_WITH_HELP_TEXT"
      [ngTemplateOutletContext]="{ headerTitle: subtotalByHeaderTitle, helpText: subtotalByHelpText, dai: 'lm-subtotal'}">
    </ng-container>
    <ng-container *ngIf="subTotalByInfo?.length === 0">
      <div class="">
        <div class="lm-font-sm">{{'NoSubtotalOptions' | translate}}</div>
      </div>
    </ng-container>
    <ng-container *ngIf="subTotalByInfo?.length > 0">
      <div class="lm-flex-row-responsive-container">
        <ng-container [ngTemplateOutlet]="SUBTOTAL_WIDGET"></ng-container>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #TOTAL_FIELDS>
    <div class="lm-flex-row-responsive-container">
      <ng-container [ngTemplateOutlet]="COLUMN_TOTAL_FIELDS"></ng-container>
      <ng-container *ngIf="!isColumnarView" [ngTemplateOutlet]="SUMMARY_TOTAL_FIELDS"></ng-container>
    </div>
    <div *ngIf="hasTotaling && !isColumnarView" class="lm-flex-row-responsive-container">
      <div class="field lm-padding-right">
        <input
                soho-checkbox
                type="checkbox"
                soho-trackdirty
                id="lm-personalization-totals-only-checkbox"
                name="lm-personalization-totals-only-checkbox"
                data-automation-id="lm-personalization-totals-only-checkbox"
                [disabled]="!hasTotaling"
                [(ngModel)]="showTotalsOnly"
        >
        <label
                soho-label
                for="lm-personalization-totals-only-checkbox"
                [forCheckBox]="true">{{'ShowTotalsOnly' | translate}}</label>
      </div>
      <div class="field">
        <input
                soho-checkbox
                type="checkbox"
                soho-trackdirty
                id="lm-personalization-suppress-subtotals-checkbox"
                name="lm-personalization-suppress-subtotals-checkbox"
                data-automation-id="lm-personalization-suppress-subtotals-checkbox"
                [disabled]="!hasTotaling"
                [(ngModel)]="suppressSubtotals"
        >
        <label
                soho-label
                for="lm-personalization-suppress-subtotals-checkbox"
                [forCheckBox]="true">{{'SuppressSubtotals' | translate}}</label>
      </div>
    </div>
  </ng-template>

  <ng-template #COLUMN_TOTAL_FIELDS>
    <ng-container [ngTemplateOutlet]="FIELD_WIDGET"
      [ngTemplateOutletContext]="{
      contentType:'Column',
      headerTitle: columnTotalWidgetTitle,
      helpText: columnTotalHelpText,
      actionText:addColumnCountButtonText,
      hasData: columnTotalFieldInfo?.length > 0 ? true : false,
      emptyMsg: emptyMessageColumnTotalFields,
      dai: 'lm-column-total-field-widget'}">
    </ng-container>
  </ng-template>

  <ng-template #SUMMARY_TOTAL_FIELDS>
    <ng-container [ngTemplateOutlet]="FIELD_WIDGET"
        [ngTemplateOutletContext]="{
        contentType:'Summary',
        headerTitle: summaryTotalWidgetTitle,
        helpText: summaryTotalHelpText,
        actionText:addSummaryTotalFieldButtonText,
        hasData: summaryTotalFields?.length > 0 ? true : false,
        emptyMsg: emptyMessageSummaryTotalFields,
        dai: 'lm-summary-field-widget'}">
    </ng-container>
  </ng-template>

  <ng-template #FIELD_WIDGET
     let-contentType="contentType"
     let-headerTitle="headerTitle"
     let-helpText="helpText",
     let-actionText="actionText",
     let-hasData="hasData",
     let-emptyMsg="emptyMsg",
     let-dai="dai">
    <div soho-widget-content class="lm-total-field-widget form-layout-compact widget">
      <div class="lm-report-widget-header">
        <div>
          <div attr.data-automation-id="{{dai}}-header" class="lm-bold lm-font-md lm-padding-right-sm">{{headerTitle}}</div>
          <lm-mouse-over-text [mouseOverTextContents]="helpText"></lm-mouse-over-text>
        </div>
      </div>
      <div class="lm-flex-row-responsive-container">
        <ng-container *ngIf="contentType==='Summary'" [ngTemplateOutlet]="SUMMARY_FIELD_CONTENT"></ng-container>
        <ng-container *ngIf="contentType==='Column'" [ngTemplateOutlet]="COLUMN_TOTAL_FIELD_CONTENT"></ng-container>
      </div>
      <div *ngIf="!hasData" class="lm-report-widget-footer">
        <div attr.data-automation-id="{{dai}}-empty-msg" class="lm-font-sm">{{emptyMsg}}</div>
      </div>
      <div *ngIf="!isColumnarView" class="lm-report-widget-footer">
        <button attr.data-automation-id="{{dai}}-add-btn"
          icon="add"
          soho-button="button"
          (click)="onAddTotal(contentType)"
          class="btn-primary">{{actionText}}</button>
      </div>
    </div>
  </ng-template>

  <ng-template #SORT_WIDGET>
     <ng-container *ngFor="let info of sortByInfo; index as i">
        <div soho-widget-content attr.data-automation-id="lm-sort-by-widget-{{info.sortOrder}}-{{i}}"
           class="widget lm-report-widget">
          <!-- HEADER -->
          <div class="lm-report-widget-header">
            <div>
               <span attr.data-automation-id="lm-sort-by-widget-used-on-text-{{info.sortOrder}}-{{i}}"
                 class="lm-bold lm-font-md lm-tooltip-on-truncate" soho-tooltip [content]="info.name">{{info.name}}
               </span>
            </div>
            <div *ngIf="info.type!=='implicit' && !isColumnarView" class="lm-flex-row-container-right">
              <button attr.data-automation-id="lm-sort-by-widget-remove-link-{{info.sortOrder}}-{{i}}"
                soho-button= "icon"
                icon="close"
                soho-tooltip
                [content]="'RemoveSortTooltip' | translate"
                (click)="onRemoveSort(info.column)">
              </button>
            </div>
          </div>
          <!-- CONTENT -->
          <div class="lm-report-sort-by-container">
            <!-- SORT FIELDS -->
             <ul>
              <div class="lm-flex-row-two-table-container">
                <div class="font-size-sm lm-bold">{{'SortBy' | translate}}</div>
              </div>
              <ng-container  *ngIf="!isColumnarView">
                <li *ngFor="let sortField of setSpecs[info.sortOrder].sortFields; index as j" attr.data-automation-id="lm-sort-by-widget-field-{{info.sortOrder}}-{{i}}-{{sortField.name}}">
                <span attr.data-automation-id="lm-sort-by-widget-field-name-{{info.sortOrder}}-{{i}}-{{sortField.name}}"
                      class="lm-font-sm"
                      soho-tooltip [content]="sortField.name">{{sortField.name}}</span>
                  <svg *ngIf="sortField.descending" soho-icon attr.data-automation-id="lm-sort-by-widget-field-descending-{{info.sortOrder}}-{{i}}-{{sortField.name}}"
                       icon="sort-down"
                       class="icon-alert-solid lm-sort-total-alert-icon"></svg>
                </li>
              </ng-container>
               <ng-container  *ngIf="isColumnarView">
                 <li attr.data-automation-id="lm-sort-by-widget-field-{{info.sortOrder}}-{{i}}">
                 <span attr.data-automation-id="lm-sort-by-widget-field-name-{{info.sortOrder}}-{{i}}"
                      class="lm-font-sm"
                      soho-tooltip [content]="info.name">{{info.name}}</span>
                 </li>
               </ng-container>

            </ul>
            <!-- ACTIONS -->
            <div class="lm-report-sort-by-action-container">
              <ng-container *ngIf="info.type === 'implicit' || info.column?.defaultSort">
                <span attr.data-automation-id="lm-sort-by-widget-is-default-tag-{{info.sortOrder}}-{{i}}"
                  class="tag good">{{'Default' | translate}}</span>
                <div *ngIf="info.column?.defaultSort"
                   class="switch"
                   id="{{info.sortOrder}}-{{i}}-lm-is-default-descending">
                  <input attr.data-automation-id="lm-sort-by-widget-is-descending-switch{{info.sortOrder}}-{{i}}"
                   type="checkbox"
                   id="lm-sort-by-widget-is-descending-switch{{info.sortOrder}}-{{i}}"
                   name="lm-sort-by-widget-is-descending-switch{{info.sortOrder}}-{{i}}"
                   [(ngModel)]="info.column.sortDescending"
                   (ngModelChange)="onSortDescendingSwitched(info.column)">
                  <label
                    soho-label
                    for="lm-sort-by-widget-is-descending-switch{{info.sortOrder}}-{{i}}">{{'ListPersonalizationSortDescendingLabel40' | translate}}</label>
                </div>
                <a *ngIf="info.column?.defaultSort" soho-hyperlink attr.data-automation-id="lm-sort-by-widget-remove-default-link{{info.sortOrder}}-{{i}}"
                   soho-button="secondary"
                   (click)="onRemoveDefault(info.column)">{{'RemoveDefaultLabel' | translate}}</a>
              </ng-container>
              <ng-container *ngIf="info.type === 'displayField' && !info.column.defaultSort">
                <a soho-hyperlink attr.data-automation-id="lm-sort-by-widget-make-default-link{{info.sortOrder}}-{{i}}"
                   soho-button="secondary"
                   (click)="onMakeDefault(info.column)">{{'MakeDefaultLabel' | translate}}</a>
              </ng-container>
            </div>
          </div>
          <!-- FOOTER -->
          <div *ngIf="!isColumnarView" class="lm-report-widget-footer">
            <svg *ngIf="setSpecs[info.sortOrder].condition" soho-icon attr.data-automation-id="lm-sort-by-widget-instance-selection-alert-{{info.sortOrder}}-{{i}}"
               icon="info"
               class="icon-alert-solid lm-sort-total-alert-icon"
               soho-tooltip [content]="setSpecs[info.sortOrder].condition"></svg>
            <span attr.data-automation-id="lm-sort-by-widget-set-name-{{info.sortOrder}}-{{i}}"
                class="lm-font-xs"
                soho-tooltip [content]="info.sortOrder"
            >{{info.sortOrder}}
                  </span>
          </div>
    </div>
      </ng-container>
  </ng-template>

  <ng-template #SUBTOTAL_WIDGET>
    <ng-container *ngFor="let info of subTotalByInfo; index as i">
      <div soho-widget-content attr.data-automation-id="lm-subtotal-by-widget-{{info.sortOrder}}-{{i}}"
       class="widget lm-report-widget">
        <!-- HEADER -->
        <div class="lm-report-widget-header">
          <div>
            <span attr.data-automation-id="lm-subtotal-by-widget-used-on-text-{{info.sortOrder}}-{{i}}"
              class="lm-bold lm-font-md lm-tooltip-on-truncate" soho-tooltip [content]="info.name">{{info.name}}
            </span>
          </div>
          <div *ngIf="info.column?.defaultSort || !info.column" class="lm-flex-row-container-right">
              <span attr.data-automation-id="lm-subtotal-by-widget-is-default-tag{{info.sortOrder}}-{{i}}"
                class="tag good lm-padding-right">{{'Default' | translate}}</span>
          </div>
        </div>
        <!-- CONTENT -->
        <div class="lm-report-sort-by-container">
          <!-- SORT FIELDS -->
          <ul>
            <div class="lm-flex-row-two-table-container">
              <div class="font-size-sm lm-bold">{{'SubTotalFieldHeader' | translate}}</div>
              <div class="font-size-sm lm-bold lm-padding-right">{{'SubTotalPageBreakHeader' | translate}}</div>
            </div>
            <li *ngFor="let subTotalInfo of info.subTotalBy; index as j" attr.data-automation-id="lm-subtotal-by-widget-field-{{info.sortOrder}}-{{i}}-{{subTotalInfo.field}}">
              <div class="lm-flex-row-two-table-container">
                <div class="lm-flex-row-container-no-wrap">
                  <input attr.data-automation-id="lm-subtotal-by-widget-field-enabled-checkbox-{{info.sortOrder}}-{{i}}-{{subTotalInfo.field}}"
                     type="checkbox"
                     soho-checkbox
                     id="lm-subtotal-by-widget-field-enabled-checkbox-{{info.sortOrder}}-{{i}}-{{subTotalInfo.field}}"
                     name="lm-subtotal-by-widget-field-enabled-checkbox-{{info.sortOrder}}-{{i}}-{{subTotalInfo.field}}"
                     soho-tooltip [content]="subTotalInfo.field"
                     [disabled]="suppressSubtotals || !hasTotaling || info.subTotalBy.length < 2 || (subTotalInfo.enabled && info.disable)"
                     [(ngModel)]="subTotalInfo.enabled"
                     (change)="onColumnSubTotalByChanged(info)"
                  >
                  <label
                      class="lm-flex-row-two-table-checkbox-cell-container"
                      soho-label
                      [forCheckBox]=true
                      for="lm-subtotal-by-widget-field-enabled-checkbox-{{info.sortOrder}}-{{i}}-{{subTotalInfo.field}}">
                  </label>
                  <label attr.data-automation-id="lm-subtotal-by-widget-field-name-{{info.sortOrder}}-{{i}}-{{subTotalInfo.field}}"
                     soho-tooltip [content]="subTotalInfo.field" soho-label class="lm-flex-row-two-table-cell-container">{{subTotalInfo.field}}
                  </label>
                </div>
                <div class="lm-flex-row-container-right">
                  <input attr.data-automation-id="lm-subtotal-by-widget-pagebreak-checkbox-{{info.sortOrder}}-{{i}}-{{subTotalInfo.field}}"
                     type="checkbox"
                     soho-checkbox
                     id="lm-subtotal-by-widget-pagebreak-checkbox-{{info.sortOrder}}-{{i}}-{{subTotalInfo.field}}"
                     name="lm-subtotal-by-widget-pagebreak-checkbox-{{info.sortOrder}}-{{i}}-{{subTotalInfo.field}}"
                     soho-tooltip [content]="subTotalInfo.field"
                     [disabled]="!subTotalInfo.enabled || suppressSubtotals || !hasTotaling"
                     [(ngModel)]="subTotalInfo.pageBreak"
                     (change)="onColumnSubTotalByChanged(info.column)">
                  <label
                    class="lm-flex-row-two-table-checkbox-cell-container lm-padding-right"
                    soho-label
                    [forCheckBox]=true
                    for="lm-subtotal-by-widget-pagebreak-checkbox-{{info.sortOrder}}-{{i}}-{{subTotalInfo.field}}">
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- FOOTER -->
        <div class="lm-report-widget-footer">
          <span attr.data-automation-id="lm-subtotal-by-widget-set-name{{info.sortOrder}}-{{i}}"
              class="lm-font-xs"
              soho-tooltip [content]="info.sortOrder">{{info.sortOrder}}
          </span>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #SUMMARY_FIELD_CONTENT>
    <ng-container *ngFor="let info of summaryTotalFieldInfo; index as i">
      <div class="lm-flex-row-container-no-wrap">
        <div class="lm-font-sm lm-total-field-container">{{info.summaryTotalFld.fieldId}}</div>
        <div class="field">
          <input attr.data-automation-id="lm-summary-field-override-label-{{info.fieldName}}-{{i}}"
            soho-trackdirty
            id="lm-summary-field-override-label-{{info.fieldName}}-{{i}}"
            name="lm-summary-field-override-label-{{info.fieldName}}-{{i}}"
            attr.placeholder="{{'OverrideDefaultLabel' | translate}}"
            [(ngModel)]="info.summaryTotalFld.label"
            (change)="onSummaryTotalFieldChange(info.summaryTotalFld)">
        </div>
        <div class="">
          <button attr.data-automation-id="lm-summary-field-remove-link{{info.fieldName}}-{{i}}"
            soho-button= "icon"
            icon="close"
            soho-tooltip
            [content]="'RemoveSummaryTotal' | translate"
            (click)="onRemoveSummaryTotal(info.summaryTotalFld)">
          </button>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #COLUMN_TOTAL_FIELD_CONTENT>
    <ng-container *ngFor="let info of columnTotalFieldInfo; index as i">
      <div class="lm-flex-row-container-no-wrap">
        <div class="lm-font-sm lm-total-field-container" soho-tooltip [content]="info.fieldName">{{info.fieldName}}</div>
        <div class="field">
          <select attr.data-automation-id="lm-column-total-{{info.fieldName}}-{{i}}"
            soho-dropdown
            noSearch
            class="lm-font-sm"
            attr.id="lm-column-total-{{info.fieldName}}-{{i}}"
            attr.name="lm-column-total-{{info.fieldName}}-{{i}}"
            [ngModel]="info.column.totaling"
            (change)="onTotalTypeChange($event, info.column)">
            <option attr.data-automation-id="lm-column-total-NONE}" [value]="'NONE'">{{'totaling.option.label.none' | translate }}</option>
            <option attr.data-automation-id="lm-column-total-TOTAL}"  [value]="'TOTAL'">{{'totaling.option.label.total' | translate}}</option>
            <option *ngIf="!isColumnarView" attr.data-automation-id="lm-column-total-RUNNING_TOTAL}" [value]="'RUNNING_TOTAL'">{{'totaling.option.label.running' | translate}}</option>
            <option *ngIf="!isColumnarView" attr.data-automation-id="lm-column-total-PERCENT_OF_TOTAL}" [value]="'PERCENT_OF_TOTAL'">{{'totaling.option.label.percent' | translate}}</option>
          </select>
        </div>
      </div>
    </ng-container>
  </ng-template>

</div>
